import { prefectureOptions } from '@js/components/common/prefectures';

const patternKatakana = /^[ァ-ヶー]+$/;
const patternJapaneseAlphabet = /^[ぁ-んァ-ヶ一-龥々ヶー﨑A-Za-z&]+$/;
const patternLargeKanaAlphabetSpace = /^[A-Zアイウエオカ-ヂツ-モヤユヨラ-ロワンヴ　ー －()（）]+$/;
const patternNumerical = /^\d+$/;
const isUploaded = (value: FileList, url: string): (boolean | string) => Boolean(value.length) || Boolean(url) || ERROR_MESSAGE.REQUIRED_FILE;
const ERROR_MESSAGE = {
  REQUIRED: '必ず入力してください',
  REQUIRED_FILE: '必ずアップロードしてください',
  REQUIRED_SELECT: '必ず選択してください',
  MAX_LENGTH_7: '7文字以下で入力してください',
  MAX_LENGTH_20: '20文字以下で入力してください',
  MAX_LENGTH_30: '30文字以下で入力してください',
  MAX_LENGTH_60: '60文字以下で入力してください',
  MAX_LENGTH_80: '80文字以下で入力してください',
  MAX_LENGTH_200: '200文字以下で入力してください',
  MAX_LENGTH_255: '255文字以下で入力してください',
  OUT_OF_RANGE_12_13: '12または13文字で入力してください',
  OUT_OF_RANGE_10_11: '10または11文字で入力してください',
  OUT_OF_RANGE_7_7: '7文字で入力してください',
  PATTERN_JAPANESE_ALPHABET: '全角の漢字・ひらがな・カタカナ、半角アルファベット、または&のいずれかで入力してください',
  PATTERN_KANA: '全角カタカナで入力して下さい',
  PATTERN_LARGE_KANA_ALPHABET: '小文字(ァ・ィ・ェ・ッ・ャ・ュ・ョ等)は利用せず全角カタカナ(ヰ・ヱ・ヲを除く)もしくは半角英字（大文字）でご入力ください',
  PATTERN_NUMERICAL: '半角数字で入力して下さい',
  PATTERN_STREET: '数字とハイフンは半角で入力してください・数字で終了してください',
};

export const CorporateRegistrationValidation = {
  name: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 200, message: ERROR_MESSAGE.MAX_LENGTH_200},
    pattern: {value: patternJapaneseAlphabet, message: ERROR_MESSAGE.PATTERN_JAPANESE_ALPHABET}
  },
  nameKana: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 200, message: ERROR_MESSAGE.MAX_LENGTH_200},
    pattern: {value: patternKatakana, message: ERROR_MESSAGE.PATTERN_KANA}
  },
  corporateNumber: {
    required: ERROR_MESSAGE.REQUIRED,
    minLength: {value: 12, message: ERROR_MESSAGE.OUT_OF_RANGE_12_13},
    maxLength: {value: 13, message: ERROR_MESSAGE.OUT_OF_RANGE_12_13}
  },
  phoneNumber: {
    required: ERROR_MESSAGE.REQUIRED,
    minLength: {value: 10, message: ERROR_MESSAGE.OUT_OF_RANGE_10_11},
    maxLength: {value: 11, message: ERROR_MESSAGE.OUT_OF_RANGE_10_11},
    pattern: {value: patternNumerical, message: ERROR_MESSAGE.PATTERN_NUMERICAL}
  },
  businessOverview: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 255, message: ERROR_MESSAGE.MAX_LENGTH_255}
  },
  pdf(validateArg: string) {
    return {
      validate: {func: (value: FileList) => {
        return isUploaded(value, validateArg);
      }}
    };
  }
};

export const AddressValidation = {
  postalCode: {
    required: ERROR_MESSAGE.REQUIRED,
    minLength: {value: 7, message: ERROR_MESSAGE.OUT_OF_RANGE_7_7},
    maxLength: {value: 7, message: ERROR_MESSAGE.OUT_OF_RANGE_7_7},
    pattern: {value: patternNumerical, message: ERROR_MESSAGE.PATTERN_NUMERICAL}
  },
  prefectureName: {
    validate: {
      func(value: string) {
        return Number(prefectureOptions.filter(option => option.name === value)[0].code) > 0 ? true : ERROR_MESSAGE.REQUIRED_SELECT;
      }
    }
  },
  city: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 30, message: ERROR_MESSAGE.MAX_LENGTH_30}
  },
  street: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 30, message: ERROR_MESSAGE.MAX_LENGTH_30},
    pattern: {
      value: /^[0-9]+(-[0-9]+){0,2}$/,
      message: ERROR_MESSAGE.PATTERN_STREET
    },
  },
  building: {
    maxLength: {value: 80, message: ERROR_MESSAGE.MAX_LENGTH_80}
  }
};

export const CorporateRepresentativeValidation = {
  lastNameKanji: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternJapaneseAlphabet, message: ERROR_MESSAGE.PATTERN_JAPANESE_ALPHABET}
  },
  firstNameKanji: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternJapaneseAlphabet, message: ERROR_MESSAGE.PATTERN_JAPANESE_ALPHABET}
  },
  lastNameKana: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternKatakana, message: ERROR_MESSAGE.PATTERN_KANA}
  },
  firstNameKana: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternKatakana, message: ERROR_MESSAGE.PATTERN_KANA}
  },
  corporate_relationship: {
    required: ERROR_MESSAGE.REQUIRED
  },
  gender: {
    required: ERROR_MESSAGE.REQUIRED
  },
  birthday: {
    required: ERROR_MESSAGE.REQUIRED
  },
  phoneNumber: {
    required: ERROR_MESSAGE.REQUIRED,
    minLength: {value: 10, message: ERROR_MESSAGE.OUT_OF_RANGE_10_11},
    maxLength: {value: 11, message: ERROR_MESSAGE.OUT_OF_RANGE_10_11},
    pattern: {value: patternNumerical, message: ERROR_MESSAGE.PATTERN_NUMERICAL}
  },
  department: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 60, message: ERROR_MESSAGE.MAX_LENGTH_60}
  },
  pdf(validateArg: string) {
    return {
      validate: {func: (value: FileList) => {
        return isUploaded(value, validateArg);
      }}
    };
  }
};

export const CorporateIdentificationValidation = {
  documentKind(firstDocumentKind: string, secondDocumentKind: string) {
    return {
      validate: {
        isDifferent: () => firstDocumentKind !== secondDocumentKind || '1つ目と2つ目では異なった本人確認書類を選択してください'
      }
    };
  },
  firstDocument: {
    required: ERROR_MESSAGE.REQUIRED,
  },
  secondDocumentKind: {
    required: ERROR_MESSAGE.REQUIRED
  },
};

export const CorporateOwningIndividualValidation = {
  lastNameKanji: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternJapaneseAlphabet, message: ERROR_MESSAGE.PATTERN_JAPANESE_ALPHABET}
  },
  lastNameKana: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternKatakana, message: ERROR_MESSAGE.PATTERN_KANA}
  },
  firstNameKanji: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternJapaneseAlphabet, message: ERROR_MESSAGE.PATTERN_JAPANESE_ALPHABET}
  },
  firstNameKana: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 20, message: ERROR_MESSAGE.MAX_LENGTH_20},
    pattern: {value: patternKatakana, message: ERROR_MESSAGE.PATTERN_KANA}
  },
  corporateRelationship:{
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 200, message: ERROR_MESSAGE.MAX_LENGTH_200}
  },
  gender: {
    required: ERROR_MESSAGE.REQUIRED
  },
  birthday: {
    required: ERROR_MESSAGE.REQUIRED
  }
};

export const CorporateOwningCorporateValidation = {
  name: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 200, message: ERROR_MESSAGE.MAX_LENGTH_200},
    pattern: {value: patternJapaneseAlphabet, message: ERROR_MESSAGE.PATTERN_JAPANESE_ALPHABET}
  },
  nameKana: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 200, message: ERROR_MESSAGE.MAX_LENGTH_200},
    pattern: {value: patternKatakana, message: ERROR_MESSAGE.PATTERN_KANA}
  },
  corporateNumber: {
    required: ERROR_MESSAGE.REQUIRED,
    minLength: {value: 12, message: ERROR_MESSAGE.OUT_OF_RANGE_12_13},
    maxLength: {value: 13, message: ERROR_MESSAGE.OUT_OF_RANGE_12_13}
  },
  corporateRelationship:{
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 200, message: ERROR_MESSAGE.MAX_LENGTH_200}
  }
};

export const BankAccountValidation = {
  bank: {
    required: ERROR_MESSAGE.REQUIRED
  },
  branch: {
    required: ERROR_MESSAGE.REQUIRED
  },
  number: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 7, message: ERROR_MESSAGE.MAX_LENGTH_7},
    pattern: {value: patternNumerical, message: ERROR_MESSAGE.PATTERN_NUMERICAL}
  },
  holderName: {
    required: ERROR_MESSAGE.REQUIRED,
    maxLength: {value: 30, message: ERROR_MESSAGE.MAX_LENGTH_30},
    pattern: {value: patternLargeKanaAlphabetSpace, message: ERROR_MESSAGE.PATTERN_LARGE_KANA_ALPHABET}
  }
};
